import { Button, Form, Popup, ScrollView, TextBox, SelectBox } from 'devextreme-react';
import { Label } from 'devextreme-react/bar-gauge';
import { SimpleItem } from 'devextreme-react/form';
import React, { useRef, useEffect } from 'react';
import { InputOnlyNumber } from '../../common';

const CardBillAccountInfoPopup = ({
  onHiding,
  onValueChanged,
  onClickSave,
  accountInfo,
  bankList,
  visibleAccountInfoPopup,
  notifyMsg,
}) => {
  // console.log('CardBillAccountInfoPopup Load');

  const refAccountNo = useRef(null);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  useEffect(() => {

  }, [visibleAccountInfoPopup]);

  return (
    <React.Fragment>
      <Popup
        title="출금계좌편집"
        fullScreen={isMobile}
        visible={visibleAccountInfoPopup}
        onHiding={onHiding}
        className="popup"
        width="370px"
        height="300px"
        showCloseButton={true}
      >
        <div className="card-bill-list-withdraw-request-content popup-content">
        <Form formData={accountInfo} labelLocation={'left'} minColWidth={50}>
            <SimpleItem>
            <Label text="은행명" />
            <SelectBox
                dataSource={bankList}
                displayExpr="Value"
                width="16rem"
                readOnly={false}
                stylingMode='outlined'
                value={accountInfo.bankCode}
                valueExpr="Code"
                onValueChanged={(e) => onValueChanged('bankCode', e)}
            />
            </SimpleItem>
            <SimpleItem>
            <Label text="계좌번호" />
            <TextBox
                width="16rem"
                readOnly={false}
                stylingMode='outlined'
                value={accountInfo.accountNo}
                onInput={(e) =>
                  InputOnlyNumber(e.event, refAccountNo.current)
                }
                onValueChanged={(e) => onValueChanged('accountNo', e)}
            />
            </SimpleItem>
            <SimpleItem>
            <Label text="예금주" />
            <TextBox
                width="16rem"
                readOnly={false}
                stylingMode='outlined'
                value={accountInfo.bankOwnerName}
                onValueChanged={(e) => onValueChanged('bankOwnerName', e)}
            />
            </SimpleItem>
        </Form>
        </div>
        <div className="card-bill-account-info-bottom">
        {/* <span className="notify-error"> notifyMsg </span> */}
        <Button
            stylingMode="contained"
            type="default"
            text="저장"
            onClick={onClickSave}
        />
        <Button
            stylingMode="contained"
            type="danger"
            text="취소"
            onClick={onHiding}
        />
        </div>
        <div className="notify">
            <span className="notify-error"> {notifyMsg} </span>
        </div>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CardBillAccountInfoPopup);
